import React from 'react'

import { Row, Col } from 'antd'

import './generatedReport.css'
import logo from '../../../assets/images/logo-big.png'

const ReportGeneralAction = function ({ page, reportProps = {}, dynamic = {} }) {
  function renderLeftSide(props) {
    if (props === null) {
      return
    }

    return (
      <Row className="column-one">
        <Col md={24}>
          <img className="logo" src={logo} alt="logo" />
          <div className="title" />
          <p className="division">Dados Gerais da Visita</p>
          {props.actionType && props.actionType.typeName && (
            <>
              <div className="sub-title">Tipo de Visita</div>
              <div className="description">{props.actionType && props.actionType.typeName}</div>
            </>
          )}
          {props.customer && props.customer.customerName && (
            <>
              <div className="sub-title">Agricultor</div>
              <div className="description">{props.customer && props.customer.customerName}</div>
            </>
          )}
          {props.location && props.location.locationName && (
            <>
              <div className="sub-title">Local</div>
              <div className="description">{props.location && props.location.locationName}</div>
            </>
          )}
          {props.member && props.member.memberName && (
            <>
              <div className="sub-title">Profissional</div>
              <div className="description">{props.member && props.member.memberName}</div>
            </>
          )}
          {props.contact && props.contact.contactName && (
            <>
              <div className="sub-title">Contatos</div>
              <div className="description">{props.contact && props.contact.contactName}</div>
            </>
          )}
          {/* {props.actionPlannedDoneTime && (
            <>
              <div class="sub-title">Data de Execução</div>
              <div class="description">Inicio</div>
              <div class="description">
                {props.actionPlannedDoneTime !== null &&
                  moment(props.actionPlannedDoneTime, 'DD/MM/YYYY HH:mm').toISOString()}
              </div>
            </>
          )} */}
          <p className="footer division">Dados do Relatório</p>
        </Col>
      </Row>
    )
  }

  function renderRightSidePageONE(properties = {}, dynamicFields) {
    return (
      <Row className="column-two">
        <Col md={24}>
          {renderTitleRight('Detalhamento')}
          {reportProps.actionNotes && (
            <>
              <div className="sub-title">Descrição</div>
              <div className="description">{reportProps.actionNotes}</div>
            </>
          )}
          {dynamicFields.length > 0 &&
            dynamicFields.map((dynamicItem) => {
              return (
                <div key={dynamicItem.id}>
                  <div className="sub-title">{dynamicItem.fieldName}</div>
                  <div className="description">{dynamicItem.answer}</div>
                </div>
              )
            })}
          {renderFooterRight(properties)}
        </Col>
      </Row>
    )
  }

  function renderImg(children, id, name) {
    return (
      <div key={id}>
        <div className="sub-title">{name}</div>
        <br />
        {children}
      </div>
    )
  }

  function renderRightSidePageTWO(properties = {}, dynamicFields) {
    const rendered = []
    return (
      <Row className="column-two">
        <Col md={24}>
          {renderTitleRight('Anexos')}
          {dynamicFields &&
            dynamicFields.map((img) => {
              if (!rendered.includes(img.id)) {
                const fileInfo = JSON.parse(img.answer)
                rendered.push(img.id)
                if (Array.isArray(fileInfo)) {
                  const imgs = []
                  let count = 0
                  for (const image of fileInfo) {
                    count++
                    if (count < 6) {
                      const caption = (image.file && image.description) || ''
                      const fileUri = image.file && image.file.fileUri

                      if (fileUri !== null) {
                        imgs.push(
                          <div style={{ display: 'inline-block' }}>
                            <div>
                              <img className="img" alt={`img-${caption}`} src={fileUri} />
                              <div className="img-name">{`${caption}`}</div>
                            </div>
                          </div>
                        )
                      }
                    }
                  }

                  return renderImg(imgs, img.id, img.fieldName)
                }
              }
            })}
          {renderFooterRight(properties)}
        </Col>
      </Row>
    )
  }

  function renderFooterRight() {
    return (
      <>
        {/* <p class="separator" /> */}
        <p className="footer-div">
          {/* <div>
            <div className="text-footer">Extraído em</div>
            <div className="sub-footer">{properties.footer1}</div>
          </div>
          <div>
            <div className="text-footer">Por</div>
            <div className="sub-footer">{properties.footer2}</div>
          </div>
          <div>
            <div className="flex">
              <div className="text-footer">{'Página '}</div>
              <div className="sub-footer">{properties.footer4}</div>
            </div>
            <div className="flex">
              <div className="text-footer">{'Visita '}</div>
              <div className="sub-footer">{properties.footer3}</div>
            </div>
          </div> */}
        </p>
      </>
    )
  }

  function renderTitleRight(text) {
    return (
      <>
        <p className="title" />
        <p className="division">{text}</p>
      </>
    )
  }

  if (page === 1 && reportProps !== null && dynamic.length > 0) {
    return (
      <div className="generalAction">
        <Col md={7}>{renderLeftSide(reportProps)}</Col>
        <Col md={17}>{renderRightSidePageONE(reportProps, dynamic)}</Col>
      </div>
    )
  }

  if (page === 2 && reportProps !== null && dynamic.length > 0) {
    return (
      <div className="generalAction">
        <Col md={7}>{renderLeftSide(reportProps)}</Col>
        <Col md={17}>{renderRightSidePageTWO(reportProps, dynamic)}</Col>
      </div>
    )
  }

  return null
}

export default ReportGeneralAction
